// extracted by mini-css-extract-plugin
export default {"ErrorPage":"ErrorPage_ErrorPage__VR4+E","ErrorPage__heading":"ErrorPage_ErrorPage__heading__f9FI0"};